import useActivePosition from 'hooks/models/position/useActivePosition';
import { isNil } from 'lodash';
import { useFeatureFlags } from 'utils/features';
import { getSafeBoolean } from 'utils/optionalUtils';

export default function useGustoIsEnabled() {
  const gustoToggledOn = useFeatureFlags('GUSTO_PAYROLL');
  const activePosition = useActivePosition();

  // TODO position?
  return getSafeBoolean(gustoToggledOn) && !isNil(activePosition) && activePosition.level === 1;
}
